import React from "react";
import { useScrollContext } from "../contexts/ScrollContext";

const Navbar = () => {
  const { currentSection, scrollToSection } = useScrollContext();

  const handleNavClick = (section) => {
    scrollToSection(section);
  };

  const navLinkClass = (section) =>
    `relative inline-block !text-white text-sm cursor-pointer
     ${currentSection === section ? "after:w-full" : "after:w-0"}
     after:absolute after:left-0 after:bottom-0 after:h-[1px]
     after:bg-white after:transition-all after:duration-300
     hover:after:w-full`;

  return (
    <nav className="fixed top-0 left-0 w-full z-50 bg-transparent">
      <div className="max-w-6xl mx-auto px-4">
        {/* Desktop: horizontal layout, Mobile: vertical centered layout */}
        <div className="flex flex-col md:flex-row items-center justify-between md:h-14 py-3 md:py-0">
          {/* Menu items - centered on mobile, left on desktop */}
          <div className="flex space-x-4 md:space-x-6 justify-center mb-2 md:mb-0">
            <span
              onClick={() => handleNavClick("home")}
              className={navLinkClass("home")}
            >
              Home
            </span>
            <span
              onClick={() => handleNavClick("projects")}
              className={navLinkClass("projects")}
            >
              Projects
            </span>
            <span
              onClick={() => handleNavClick("about")}
              className={navLinkClass("about")}
            >
              About
            </span>
            <span
              onClick={() => handleNavClick("contact")}
              className={navLinkClass("contact")}
            >
              Contact
            </span>
          </div>

          {/* Scroll to explore - centered below nav on mobile, right on desktop */}
          <div className="text-white text-xs md:text-sm bg-transparent pr-[2px] animate-blink text-center md:text-left">
            Welcome to my world | Scroll to Explore
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
